/**
 * @desc 应收账单导出
 */
const URL = "/rantion-business";
import http, { updateResponse } from "@/http";
export function request(params: API.business.paymentOrder.exporting.Params, options?: any) {
  return updateResponse(
    http(URL + `/oms/paymentOrder/export`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
